import { Flex, Icon } from '@chakra-ui/react';
import { useField } from 'formik';
import { FaStar } from 'react-icons/fa';
import { Star01 } from '@/assets/icons/scorecard';

export const StarField = ({ item }) => {
  const { name, count = 5, disabled = false, editable = true } = item;

  const stars = Array.from({ length: count }, () => count);
  // eslint-disable-next-line no-unused-vars
  const [formField, meta, helpers = {}] = useField(name);
  const { setValue } = helpers || {};
  const { value } = meta;

  const handleClick = (number) => {
    setValue(number);
  };

  return (
    <Flex gap="12px" pointerEvents={!editable ? 'none' : 'auto'}>
      {stars?.map((_, index) => (
        <Icon
          as={index + 1 <= value ? FaStar : Star01}
          width="24px"
          height="24px"
          key={index}
          color={index + 1 <= value ? 'ats-primary' : 'unset'}
          onClick={() => !disabled && handleClick(index + 1)}
          cursor={disabled ? 'not-allowed' : 'pointer'}
          opacity={disabled ? 0.5 : 1}
        />
      ))}
    </Flex>
  );
};
